import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type * as dms from '../../../../dms'
import type { Plugin } from '../plugin'

/**
 * Reloads descendant options after an entity selection is persisted
 */
export const loadDescendantOptionsOnSelection = store.effects.create(
  (feature: Plugin['feature'], schemaFeature: dms.schema.Feature) =>
    feature.actions.setSelection.success.observe().pipe(
      rxjsUtils.latestFrom(action => ({
        action: rxjs.of(action),
        schema: schemaFeature.selectors.schema.asObservable,
      })),
      rxjs.mergeMap(({ action, schema }) => {
        const { entityId: ancestorEntityId, recordIds: ancestorIds } =
          action.data.request

        const descendantEntityIds = schema
          .getDescendantsOf(ancestorEntityId)
          .map(({ id }) => id)

        if (descendantEntityIds.length === 0) {
          return rxjs.of(store.effects.SKIP)
        }

        return feature.actions.loadOptions.from(action).bulkCreate(
          ...descendantEntityIds.map(entityId => ({
            criteria: {
              ancestorEntityId,
              ancestorIds,
              entityId,
            },
          })),
        )
      }),
    ),
)
